import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Home from "../Routes/Home";
import Movies from "../Routes/Movies";
import Series from "../Routes/Series";
import MovieDetail from "../Routes/MovieDetail";
import SeriesDetail from "../Routes/SeriesDetail";
import ScrollToTop from "../Components/ScrollToTop";
import Community from "../Routes/Community";
import Shortz from "../Routes/Shortz";
import Watchlist from "../Routes/Watchlist";
import ErrorBoundary from "../Routes/ErrorBoundary";
import PrivacyPolicy from "../Routes/PrivacyPolicy";
import UserPosts from "../Routes/UserPosts";
import PersonDetails from "../Routes/PersonDetails";
import DeleteAccountPage from "../Routes/DeleteAccountPage";
import SubscribePage from "../Routes/SubscribePage";
import LoginPage from "../Routes/LoginPage";
import OtpPage from "../Routes/OtpPage";
import SubscriptionProcessing from "../Routes/SubscriptionProcessing";
import UnsubModal from "../Components/Modals/UnsubModal";
import { useAppSelector } from "../Store/hooks";
import Auth from "../Components/Auth";

const Routing = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <SubscribePage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/login",
      element: <LoginPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/otp",
      element: <OtpPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/subscription-processing",
      element: <SubscriptionProcessing />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/home",
      element: (
        <Auth>
          <ScrollToTop />
          <Home />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/movies",
      element: (
        <Auth>
          <ScrollToTop />
          <Movies />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/series",
      element: (
        <Auth>
          <ScrollToTop />
          <Series />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/movies/:movieId/:movieName",
      element: (
        <Auth>
          <ScrollToTop />
          <MovieDetail />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/series/:seriesId/:seriesName",
      element: (
        <Auth>
          <ScrollToTop />
          <SeriesDetail />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/community",
      element: (
        <Auth>
          <ScrollToTop />
          <Community />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/shortz",
      element: (
        <Auth>
          <ScrollToTop />
          <Shortz />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/privacy-policy",
      element: (
        <Auth>
          <ScrollToTop />
          <PrivacyPolicy />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/user-posts",
      element: (
        <Auth>
          <ScrollToTop />
          <UserPosts />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/person/:personId/:personName",
      element: (
        <Auth>
          <ScrollToTop />
          <PersonDetails />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    // {
    //   path: "/delete-account",
    //   element: (
    //     <>
    //       <ScrollToTop />
    //       <DeleteAccountPage />
    //     </>
    //   ),
    // },
    // {
    //   path: "/watchlist",
    //   element: <Watchlist />,
    // },
    {
      path: "*",
      element: <Navigate to="/" />,
      errorElement: <ErrorBoundary />,
    },
  ]);

  const {unsubModal}=useAppSelector(state=>state.unsubModalSlice);
  return (
    <>
      <RouterProvider router={router} />
      {unsubModal && 
      <UnsubModal />
      }
    </>
  );
};

export default Routing;
